import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import { URLS } from '../../../_config';
import General from './_components/general';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import Notes from './_components/notes';
import Attachments from './_components/attachments';
import LocationWiseStock from './_components/locationWiseStock';
import PurchaseHistory from './_components/purchaseHistory';
import StockPickingHistory from './_components/stockPickingHistory';
import StockCycleCountHistory from './_components/stockCycleCountHistory';
import StockAdjustmentHistory from './_components/stockAdjustmentHistory';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import CreateSpearparts from './_components/createSpearparts';
import { Dropdown, Menu } from '../../../components/Dropdown';
import Icon from '../../../components/icons';

const SpearPartsDetails: React.FC = () => {
    const [tab, setTab] = useState('general');
    const spearPartsAPI = useSpearPartsApi();
    const params: any = useParams();
    const [partDetails, setPartDetails] = useState<any>(null)
    const [editData, setEditData] = useState<any>(null);
    const createPartRef: any = React.createRef<HTMLButtonElement>();
    const addNewRef: any = React.createRef<HTMLButtonElement>();

    const getSpearPartsList = (_partId: any) => {
        spearPartsAPI.getSpearPartsList({ partsID: _partId }, (data: any) => {
            setPartDetails(data?.sparePartsList ? data.sparePartsList[0] : []);
        }, (error: any) => {
            setPartDetails([]);
        });
    };

    console.log('partDetails', partDetails);

    useEffect(() => {
        if (params.id) {
            getSpearPartsList(params.id);
        }
    }, [params]);

    return (
        <Layout>
            <Header title={partDetails?.sparePartsName} back={URLS.INVENTORY.SPEAR_PARTS.LIST}>
                <Header.Right>
                <Drawer _ref={addNewRef} onClose={() => {
                        setEditData(null)
                        createPartRef?.current?.reset()
                    }
                    } outsideClose={false}>
                        <Drawer.Button>
                            <Button theme='light' disabled>Edit</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Parts' : 'Create New Parts'} className='!w-[39.563rem]'>
                            <CreateSpearparts _ref={createPartRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                //getSpearPartsList();
                                addNewRef.current.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewRef.current.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    <Button disabled >Create Purchase Request</Button>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary' className='h-[2.25rem]' disabled><Icon name='threedote' size={1.25} className='' /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu onClick={()=>{}}>Delete</Menu>
                            <Menu onClick={()=>{}}>Duplicate</Menu>
                            <Menu onClick={()=>{}}>Move</Menu>
                        </Dropdown.Content>
                    </Dropdown>


                </Header.Right>


            </Header>

            <div className='px-5 border-b border-gray-200 h-[3.75rem] flex items-center gap-[2.188rem] text-gray-600 text-[0.938rem] font-medium'>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'general' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('general')}>
                    General
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'LocationWiseStock' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('LocationWiseStock')}>
                    Location Wise Stock
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'PurchaseHistory' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('PurchaseHistory')}>
                    Purchase History
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'StockPickingHistory' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('StockPickingHistory')}>
                    Stock Picking History
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'StockAdjustmentHistory' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('StockAdjustmentHistory')}>
                    Stock Adjustment History
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'StockCycleCountHistory' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('StockCycleCountHistory')}>
                    Stock Cycle Count History
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'notes' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('notes')}>
                    Notes
                </button>
                <button className={`hover:text-black relative flex h-full items-center ${tab == 'attachments' ? 'text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1' : ''}`} onClick={() => setTab('attachments')}>
                    Attachments
                </button>
            </div>
            <div className='px-5'>
                {tab === 'general' && <General partDetails={partDetails} />}
                {tab === 'LocationWiseStock' && <LocationWiseStock partDetails={partDetails} />}
                {tab === 'PurchaseHistory' && <PurchaseHistory partDetails={partDetails} />}
                {tab === 'StockPickingHistory' && <StockPickingHistory partDetails={partDetails} />}
                {tab === 'StockAdjustmentHistory' && <StockAdjustmentHistory partDetails={partDetails} />}
                {tab === 'StockCycleCountHistory' && <StockCycleCountHistory partDetails={partDetails} />}

                {tab === 'notes' && <Notes />}
                {tab === 'attachments' && <Attachments />}
            </div>
        </Layout>
    );
};

export default SpearPartsDetails;